import { Avatar } from "@nextui-org/avatar";
import Link from "next/link";

function ListItemDocument({ doc, path }) {
  let keywordStr = createStr(doc.keyword);
  let contributorStr = createStr(doc.contributor_name);

  function createStr(list) {
    if (!list) {
      return "";
    }
    return list.join(", ");
  }

  return (
    <Link href={path}>
      <li
        key={doc.id}
        className="mb-5 bg-white p-8 rounded-lg shadow-lg w-full border"
      >
        <h2 className="text-lg font-bold text-blue-700 mb-5 line-clamp-2">
          {doc.title}
        </h2>
        <div className="flex sm:flex-row flex-col gap-10">
          <div className="flex flex-col items-center justify-center">
            <div>
              <Avatar
                src="/docs.png"
                className="w-20 h-20 text-large bg-transparent"
                radius="sm"
              />
            </div>
            <div className="font-bold text-center text-tiny w-24">
              {doc.publications_subtype}
            </div>
          </div>

          <div className="flex flex-col justify-center text-sm ">
            <div className="flex flex-row gap-5 ">
              <span className="font-bold"> Abstract: </span>
              <span className="line-clamp-2 text-justify">
                {doc.abstract && doc.abstract}
              </span>
            </div>
            <div className="text-gray-700 text-xs">
              <div className="flex flex-row gap-5">
                <span className="font-bold"> Palabras claves: </span>
                <div className="line-clamp-2 ">
                  <span className="italic">{keywordStr}</span>
                </div>
              </div>
              <div className="flex flex-row gap-5">
                <span className="font-bold"> Autores: </span>
                <div className="line-clamp-2 ">
                  <span>{contributorStr}</span>
                </div>
              </div>
              <div className="flex flex-row gap-5 items-center justify-start ">
                <span className="font-bold"> Fuentes: </span>
                <div className="line-clamp-2 uppercase flex flex-row items-center justify-start gap-4">
                  {doc.origin &&
                    doc["origin"].map((origin, index) => {
                      return (
                        <div
                          className="flex flex-row items-center justify-start gap-1"
                          key={`${origin}-${index}`}
                        >
                          <span>{origin}</span>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </Link>
  );
}

export default ListItemDocument;
